import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './hooks/useAuth';
import Navigation from './components/Navigation';
import DebateEngine from './components/DebateEngine';
import Login from './components/Login';
import About from './pages/About';
import History from './components/History';
import Account from './components/Account';
import CommunityHub from './components/CommunityHub';
import { useAuth } from './hooks/useAuth';
import CommunityLibrary from './components/CommunityRankings';
import DebateDetail from './pages/DebateDetail';
import { ForumThreadView } from './components/ForumThreadView';

// Protected Route component
const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user } = useAuth();
  if (!user) {
    return <Navigate to="/login" />;
  }
  return <>{children}</>;
};

const App: React.FC = () => {
  return (
    <AuthProvider>
      <Router>
        <div className="min-h-screen bg-gray-900 text-white">
          <Navigation />
          <Routes>
            <Route path="/" element={<Navigate to="/community/ranking" replace />} />
            <Route path="/history" element={
              <ProtectedRoute>
                <History />
              </ProtectedRoute>
            } />
            <Route path="/community/*" element={<CommunityHub />}>
              <Route path="ranking" element={<CommunityLibrary />} />
              <Route path="history" element={<Navigate to="/community/history" replace />} />
            </Route>
            <Route path="/debate/:debateId" element={<DebateDetail />} />
            <Route path="/debate/:debateId/discussion/:discussionId" element={<ForumThreadView />} />
            <Route path="/engine" element={<DebateEngine />} />
            <Route path="/about" element={<About />} />
            <Route path="/login" element={<Login />} />
            <Route path="/account" element={
              <ProtectedRoute>
                <Account />
              </ProtectedRoute>
            } />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
};

export default App; 